import React, { useEffect, useState } from 'react';
import { useSwipeable } from 'react-swipeable';
import { dataFetcher } from '../../Utils/dataFetcher';
import GuideAnimation from '../GuideAnimation';
import { GAtrack } from '../../Utils/tracking';
import { wrap } from 'popmotion';

import styles from './animated-guide.module.scss';
import { AnimatePresence, motion } from 'framer-motion';

const AnimatedGuide = ({ config }) => {
  const [data, setData] = useState(undefined);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(1);

  const variants = {
    enter: (direction) => {
      return {
        x: direction > 0 ? 1000 : -1000,
        opacity: 0
      };
    },
    center: {
      x: 0,
      opacity: 1,
      transitionEnd: {
        zIndex: 1
      }
    },
    exit: (direction) => {
      return {
        zIndex: 0,
        x: direction < 0 ? 1000 : -1000,
        opacity: 0
      };
    }
  };

  useEffect(() => {
    dataFetcher(config.dataUri).then((data) => {
      setData(data);
    });

    const dataLayerArgs = {
      // dataLayer: {
      event: 'rbVideoTracking',
      event_name: 'video_sidebar',
      video_sidebar: {
        value: 'Navigation',
        widget_type: `AnimatedGuide - ${config.trackingTitle || config.navigationTitle}`
      }
      // }
    };

    GAtrack(dataLayerArgs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tagChange = (option, direction = 'next') => {
    const dataLayerArgs = {
      // dataLayer: {
      event: 'rbVideoTracking',
      event_name: 'video_sidebar',
      video_sidebar: {
        value: `Slider – ${direction}${option.headline ? ` - ${option.headline}` : ''}`,
        widget_type: `AnimatedGuide - ${config.trackingTitle || config.navigationTitle}`
      }
      // }
    };

    GAtrack(dataLayerArgs);
  };

  const MotionCard = motion.custom(GuideAnimation);

  const toPreviousAnimation = () => {
    const nextIndex = wrap(0, data.length, currentIndex - 1);
    tagChange(data[nextIndex], 'Next');
    setDirection(0);
    setCurrentIndex(nextIndex);
  };

  const toNextAnimation = () => {
    const nextIndex = wrap(0, data.length, currentIndex + 1);
    tagChange(data[nextIndex], 'Next');
    setDirection(1);
    setCurrentIndex(nextIndex);
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: toPreviousAnimation,
    onSwipedRight: toNextAnimation
  });

  return (
    <>
      {data && data[currentIndex] && (
        <div>
          <AnimatePresence initial={false}>
            <MotionCard
              variants={variants}
              exit="exit"
              initial="enter"
              animate="center"
              custom={direction}
              transition={{
                x: { type: 'spring', stiffness: 300, damping: 30 },
                opacity: { duration: 1.2 }
              }}
              suffix={data[currentIndex].suffix}
              animationPath={config.animationPath}
              config={data[currentIndex]}
              animationDuration={config.animationDuration || 500}
              eventType={config.eventType}
              {...swipeHandlers}
            />
          </AnimatePresence>
          <div
            className={`${styles.controlls}`}
            style={{ top: config.arrowPostionFromTop }}
            onClick={toPreviousAnimation}
          ></div>
          <div
            className={`${styles.controlls} ${styles.right}`}
            style={{ top: config.arrowPostionFromTop }}
            onClick={toNextAnimation}
          ></div>
        </div>
      )}
      {(!data || !data[currentIndex]) && <>loading...</>}
    </>
  );
};

export { AnimatedGuide };
